import type { Components } from "react-markdown";

import { env } from "@/env";

export const CAREPLAN_PRODUCT_FORMAT = {
  CAPSULES: "Capsules",
  INHALER: "Inhaler",
  BEVERAGE_SHOT: "Beverage Shot",
  GEL_TINCTURE: "Gel Tincture",
  GEL_TOPICAL: "Gel Topical",
  GUMMIES: "Gummies",
} as const;

export const CAREPLAN_CHANGE_ATTRIBUTES = {
  PRODUCT: "product",
  DOSAGE: "product_dosage",
  FREQUENCY: "product_frequency",
  TIME_OF_USE: "product_time_of_use",
} as const;

export const CAREPLAN_PRODUCT_ROLE = {
  FOUNDATIONAL: "foundational",
  ADHOC: "adhoc",
  BEDTIME: "bedtime",
} as const;

export const FREE_SHIPPING_OPTION = "Free";

export const NO_DISCOUNT_CODE = "NO_CODE";

export const SHORT_NAME_METAFIELD_KEY = "product_short_name";

export const SHIPPING_OPTION_CODE_TO_TITLE_MAP = {
  [env.VITE_SHIPPING_OPTION_CODE_STANDARD]: "Standard Delivery (3-5 Days)",
  [env.VITE_SHIPPING_OPTION_CODE_2_DAY_DELIVERY]: "2-Day Delivery",
} as const;

export const UPDATED_INSTRUCTIONS_MARKDOWN_STYLES: Components = {
  strong: (props) => {
    return <strong {...props} className="bg-accent-surface" />;
  },
};

export const DISCOUNT_CODE_ACTIONS = {
  APPLY: "apply",
  REMOVE: "remove",
} as const;
